import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';

const SimpleModal = ({ inProgress, text, buttonFunction }) => {


  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  };

  return (
    <Modal
      open={inProgress}
    >
      <Box sx={modalStyle}>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
          {!buttonFunction && <CircularProgress color="secondary" />}
          <Typography variant="h6" color="primary">{text}</Typography>
        </Box>
        {buttonFunction && <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button variant="contained" onClick={buttonFunction}>OK</Button>
        </Box>}
      </Box>
    </Modal>
  )
}

export default SimpleModal;